import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postPaymentList: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.payment.list,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postPaymentInfo: (params: CommonIdReqDto): Promise<PaymentInfoResDto> =>
    request({
      url: endpoints.payment.info,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postPaymentRequstInfo: (params: CommonIdReqDto): Promise<PaymentRequestDetailResDto> =>
    request({
      url: endpoints.payment.info_request,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postPaymentConfirm: (params: PaymentItemDto): Promise<CommonResDto> =>
    request({
      url: endpoints.payment.info_confirm,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postPaymentUpdate: (params: PaymentItemDto): Promise<CommonResDto> =>
    request({
      url: endpoints.payment.info_update,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postPaymentInsert: (params: PaymentInsertReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.payment.info_add,
      method: 'post',
      data: paramsToFormData(params),
    }),     
};
